export class Financial{
    typeTransaction: string ="";
    valueTransaction: string ="";
    codeMessage: string ="";
    nsuTerminal: string ="";
    mmddhhmmss: string ="";
    processingCode: string ="";
    nsuAnswer: string ="";
    type: number;
    plots: string ="";
    flag: string = "";
}
